<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<div class="inner-wrap">

  <form [formGroup]="form" >
    <div class="unsubscribe">
      <p class="question1">한국냉동공조산업협회에서 발송하는 이메일을<br/><span>수신거부 하시겠습니까?</span></p>

      <div class="question-div">
        <p class="txt">고객님의 수신 거부 요청은 자동으로 처리 됩니다.</p>
	      <input type="email" formControlName="email" placeholder="수신거부 메일주소 입력" />

	      <p class="question2">이메일 서비스를 더 이상 받지 않으시겠습니까?<br/>(To unsubscribe E-mail, Click on the "예" button)</p>

	      <div class="btn-area">
	        <button type="button" class="btn yes-btn" (click)="setUnsubscribe()">예</button>
	        <button type="button" class="btn" routerLink="/main" >아니오</button>
	      </div>
      </div>
    </div>

  </form>

</div>

<app-footer></app-footer>